import ReactDOM from 'react-dom/client';
import App from './App';
import { Auth0ProviderWithNavigate } from './auth/Auth0';
import './index.css';

import { registerServiceWorker } from './serviceWorker';
import { ThemeProvider } from './contexts/ThemeContext';

registerServiceWorker();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <ThemeProvider>
    <Auth0ProviderWithNavigate>
      <App />
    </Auth0ProviderWithNavigate>
  </ThemeProvider>,
);
